<template>
  <div class="headerDiv">
    <div style="display:flex ;align-items: center;">
      <img src="../assets/pic.png" style="width: 52px;" :style="showLeftMenu?'margin-left: 20px':'margin-left: 5px'">
      <img v-if="showLeftMenu" src="../assets/pic0.png" style="width: 95px">
      <span class="headerTitle" :style="showLeftMenu?'marginLeft:65px':'marginLeft:35px'">交付系统</span>
    </div>
    <div style="display: flex;gap: 30px;align-items: center;margin-right: 20px">
      <l-e-drop-down-route :ipInfo="ipInfo"></l-e-drop-down-route>
      <l-e-bio-cloud-link :linkUrl="linkUrl"></l-e-bio-cloud-link>
      <el-dropdown @command="handleCommandTickets"
                   v-if="['ADMIN','MANAGER','TECH'].includes(role)||user?.type==='CUSTOMER'">
        <span class="el-dropdown-link">工单中心<i class="el-icon-tickets"></i><i
            class="el-icon-arrow-down el-icon--right"></i></span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item icon="el-icon-chat-line-square" command="feedBack"
                            v-if="['ADMIN','MANAGER'].includes(role)||user?.type==='CUSTOMER'">提交工单
          </el-dropdown-item>
          <el-dropdown-item icon="el-icon-time" command="history">历史工单</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown @command="handleCommand">
        <span class="el-dropdown-user">{{ user?.realName }}<i class="el-icon-arrow-down el-icon--right"></i></span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item icon="el-icon-user" command="info" v-if="user?.type==='CUSTOMER'">个人中心
          </el-dropdown-item>
          <el-dropdown-item icon="el-icon-switch-button" command="exit">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

  </div>
</template>

<script>
import {drownIcon, messageIcon, webIcon} from "@/utils/iconUtils";
import {getDataInLocalStorage} from "@/utils/localStorage";
const baseFeedBackUrl = window.location.origin + process.env.VUE_APP_FEEDBACK_API

export default {
  name: "Header",
  data() {
    return {
      linkUrl: process.env.VUE_APP_BIO_CLOUD_LINK,
      role: this.$store.getters["right/getRole"],
      isCollapse: false,
      currentNavList: [],
      messageIcon: messageIcon,
      webIcon: webIcon,
      drownIcon: drownIcon,
      user: {},
      ipInfo: {
        mainIp: process.env.VUE_APP_MAIN_IP,
        liantongIp: process.env.VUE_APP_LIANTONG_IP,
        dianxinIp: process.env.VUE_APP_DIANXIN_IP
      },
      linkUrl: process.env.VUE_APP_BIO_CLOUD_LINK,
    }
  },
  computed: {
    showLeftMenu() {
      return this.$store.getters['dataStatus/getShowLeftMenu']
    },
    currentNav() {
      return this.$route.name.split('/')
    },
    token() {
      return this.$store.getters["right/getToken"]
    }
  },
  created() {
    this.user = this.$store.getters["right/getUser"]
  },
  watch: {
    token: {
      handler: function (newVal, oldVal) {
        if(newVal&&oldVal||(oldVal&&!newVal)){
          location.reload()
        }
      },
    }
  },
  methods: {
    handleClose(item, index) {
      if (this.currentNavList.length !== 1) {
        if (this.$router.name === item) {
          this.$router.push(this.currentNavList[index - 1])
          // this.currentNavList.splice(index,1)
        }
      } else {
        this.$messageUi.error('当前已是最后')
      }
    },
    handleClick(name) {
      this.$router.push({name: name})

    },
    changeLeftNav() {
      this.$store.commit('dataStatus/setShowLeftMenu')
    },
    handleCommand(command) {
      if (command === 'info') {
        this.$router.push('/info')
      } else {
        this.$router.push('/login')
      }
    },
    handleCommandTickets(command) {
      switch (command) {
        case 'feedBack':
          window.open(baseFeedBackUrl + 'forms/out');
          break;
        case 'history':
          window.open(baseFeedBackUrl + 'forms/over');
          break;
      }
    },

  }
}
</script>

<style scoped>

.headerDiv {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0px;

}

.el-dropdown-link {
  cursor: pointer;
  color: #0a77bd;
  font-size: 15px;
}

.el-dropdown-link:hover {

  color: #2975e3;
}

.el-dropdown-user {
  cursor: pointer;
  font-size: 15px;
}

.el-dropdown-user:hover {
  color: #2975e3;
}

.routerTag {
  cursor: pointer;
}

.routerTag:hover {
  background-color: #5ba8f5;
  color: white;
}

.headerTitle {
  font-size: 23px;
  color: #111111;
  font-family: "Microsoft YaHei";
}


/deep/ .el-dropdown-menu {
  padding: 0px !important;
}
</style>
